export enum RequestTypesEnum {
  Residential = 'RESIDENTIAL',
  Commercial = 'COMMERCIAL',
  MixedUse = 'MIXED',
  Subdivision = 'SUBDIVISION',
  MultiFamily = 'MULTI FAMILY',
  Industrial = 'INDUSTRIAL'
}
